var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"type":"card-heading, image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }